import {
  Avatar,
  Button,
  Checkbox,
  Col,
  Mentions,
  Modal,
  Progress,
  Radio,
  Row,
  Upload,
} from "antd";
import React, { useEffect, useState } from "react";
import { formatTime } from "../../../utils/formatTime";

import {
  CloseOutlined,
  FolderOpenOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import "./style.scss";
import { FaTrash } from "react-icons/fa6";
import { useInfoUser } from "../../../store/UserStore";
import { MemberProjectModal } from "../MemberProjectModal";
import {
  NOTIFICATION_STATUS,
  TASK_ACTIVITY_TYPE,
} from "../../../config/Constant";
import Cookies from "js-cookie";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { handleCancelDownload } from "../../../utils/DownloadFile";
import apiFactory from "../../../api";
import { toast } from "react-toastify";
import { getFileIcon } from "../../../utils/SendFile";
import {
  isSupportedFileType,
  openNotificationError,
  standardizeVolume,
} from "../../../utils/Utils";
import { useUploadFileStore } from "../../../store/UploadFileStore";
import { PreviewFile } from "../../chat/PreviewFile";
import _ from "lodash";
import FilePreviewModal from "../FilePreviewModal";
import { ReplyCommentFile } from "./ReplyCommentFile";
import { DowloadAllReplyComment } from "./DowloadAllReplyComment";

const modules = {
  toolbar: [
    [{ font: [] }],
    [{ size: [] }],
    [{ align: [] }],
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    ["bold", "italic", "underline"],
    [{ color: [] }, { background: [] }],
  ],
};

const formats = [
  "font",
  "size",
  "align",
  "list",
  "bullet",
  "bold",
  "italic",
  "underline",
  "color",
  "background",
];

const ModalReplyComment = ({
  type,
  currentComment,
  isModalReplyComment,
  setIsModalReplyComment,
  memberList,
  getPropertyColorByType,
  getAvatarSrc,
  getMemberName,
  workActivity,
  selectedTask,
  parentTaskActivity,
  setCommentList,
  filesPreviewComment = [],
  setFilesPreviewComment = () => {},
  handleChangeUpload,
  taskFormData,
  setTaskFormData,
}) => {
  const { user, languageMap } = useInfoUser();
  const [initValue, setInitValue] = useState(null);
  const [mentionsOptionDefault, setMentionsOptionDefault] = useState([]);
  const [mentionsOption, setMentionsOption] = useState([]);
  const [isModalMentionMember, setIsModalMentionMember] = useState(false);
  const [deletedOptions, setDeletedOptions] = useState([]);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [oldContent, setOldContent] = useState("");
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [abortController, setAbortController] = useState(null);
  const [isActionDisabled, setIsActionDisabled] = useState(false);
  const [isActionDisabled2, setIsActionDisabled2] = useState(false);
  const [isFilePreviewModal, setIsFilePreviewModal] = useState(false);
  const [urlPreview, setUrlPreview] = useState(null);
  const [resourceId, setResourceId] = useState(null);
  const { uploadFilesComment, uploadFilesReply } = useUploadFileStore();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const formDataComment =
    taskFormData[type + selectedTask?.taskCode] ||
    setTaskFormData({
      type: "RESET_FORM",
      taskCode: type + selectedTask?.taskCode,
    });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (type === "EDIT") return;
    setUploadFiles(type === "COMMENT" ? uploadFilesComment : uploadFilesReply);
  }, [uploadFilesComment, uploadFilesReply]);

  const handleDeleteFile = (id) => {
    const updateFiles = filesPreviewComment.filter(
      (file) => file?.requestUuid !== id
    );
    setFilesPreviewComment(updateFiles);
  };

  const handleSelectMentions = (option) => {
    setDeletedOptions((prevDeleted) => [...prevDeleted, option.value]);
    setMentionsOption((prevOptions) =>
      prevOptions.filter((item) => item.value !== option.value)
    );
  };

  const handleChangeMentions = (value) => {
    setTaskFormData({
      type: "UPDATE_FIELD",
      taskCode: type + selectedTask?.taskCode,
      field: "mentionInput",
      value,
    });

    const updateMentions = mentionsOptionDefault
      .filter((item) => value.includes(item?.name))
      .map((item) => item?.userCode);

    setTaskFormData({
      type: "UPDATE_FIELD",
      taskCode: type + selectedTask?.taskCode,
      field: "mentionCodes",
      value: updateMentions.length > 0 ? updateMentions : [],
    });

    const deletedValues = deletedOptions.filter(
      (deletedOption) => !value.includes(deletedOption)
    );

    const restoredOptions = deletedValues
      .map((deletedValue) =>
        mentionsOptionDefault.find((item) => item.name === deletedValue)
      )
      .filter(Boolean);

    setMentionsOption((prevOptions) => [...prevOptions, ...restoredOptions]);

    setDeletedOptions((prevDeleted) =>
      prevDeleted.filter((deletedOption) => value.includes(deletedOption))
    );
  };

  const handleSubmitMentionMember = (mentionMembers) => {
    setTaskFormData({
      type: "UPDATE_FIELD",
      taskCode: type + selectedTask?.taskCode,
      field: "mentionCodes",
      value: _.uniq([...formDataComment.mentionCodes, ...mentionMembers]),
    });

    const mentionMemberFilter = mentionsOption.filter((item) =>
      mentionMembers.includes(item?.userCode)
    );

    const updateMentionsValue = mentionMemberFilter.map(
      (item) => `@${item.value}`
    );

    mentionMemberFilter.forEach((mention) => {
      setDeletedOptions((prevDeleted) => [...prevDeleted, mention.value]);
      setMentionsOption((prevOptions) =>
        prevOptions.filter((item) => item?.value !== mention.value)
      );
    });
    setTaskFormData({
      type: "UPDATE_FIELD",
      taskCode: type + selectedTask?.taskCode,
      field: "mentionInput",
      value: formDataComment.mentionInput + updateMentionsValue.join(" "),
    });
    setIsModalMentionMember(false);
  };

  const handleSubmitRemoveMember = () => {};

  const checkDisableFromEdit = () => {
    let isDisable = false;

    if (type === "COMMENT" || type === "REPLY") return isDisable;

    // if (type === "EDIT") {
    //   const isNotificationStatus = initValue?.notificationStatus === NOTIFICATION_STATUS.YES;
    //
    //   if (initValue?.content === content && isNotificationStatus === isRegisterNotice) {
    //     isDisable = true;
    //   }
    //
    // }
    return isDisable;
  };

  const validateContent = () => {
    if (!["COMMENT", "REPLY", "EDIT"].includes(type)) return true;

    if (type === "EDIT") {
      if (!formDataComment?.content || !oldContent) return true;

      const parser = new DOMParser();
      const doc = parser.parseFromString(formDataComment?.content, "text/html");
      const plainText = doc?.body?.textContent?.trim();

      return plainText?.length === 0 || plainText === oldContent?.trim();
    }

    if (!formDataComment?.content) return true;

    const parser = new DOMParser();
    const doc = parser?.parseFromString(formDataComment?.content, "text/html");

    const textContent = doc?.body?.textContent?.trim();

    return textContent?.length === 0;
  };

  const truncateFileName = (fileName, maxLength = 40) => {
    const dotIndex = fileName.lastIndexOf(".");
    const namePart = dotIndex !== -1 ? fileName.slice(0, dotIndex) : fileName;
    const extPart = dotIndex !== -1 ? fileName.slice(dotIndex) : "";

    if (namePart.length > maxLength) {
      return namePart.slice(0, maxLength) + "..." + extPart;
    }
    return fileName;
  };

  const commentReply = () => {
    const userIds = memberList.map((member) => member.userId);

    const plainText = formDataComment.content?.replace(/<\/?[^>]+(>|$)/g, "");

    if (plainText?.trim()?.length === 0 && filesPreviewComment?.length === 0) {
      return;
    }

    const request = {
      token: Cookies.get("access_token"),
      taskCode: selectedTask?.taskCode,
      projectCode: selectedTask?.projectCode,
      activeType:
        type === "COMMENT"
          ? TASK_ACTIVITY_TYPE.COMMENT
          : TASK_ACTIVITY_TYPE.REPLY,
      notificationStatus: formDataComment.isRegisterNotice
        ? NOTIFICATION_STATUS.YES
        : NOTIFICATION_STATUS.NO,
      typeCode: formDataComment.selectedWorkActivity,
      content: formDataComment.content,
      parentTaskActivityCode: parentTaskActivity ? parentTaskActivity : null,
      mentionCodes: formDataComment.mentionCodes,
      filePaths: filesPreviewComment?.map((file) => file?.pathUrl),
      userIds: userIds,
    };

    apiFactory.taskApi.commentReply(request);

    setFilesPreviewComment([]);
    setTaskFormData({
      type: "RESET_FORM",
      taskCode: type + selectedTask?.taskCode,
    });
    //client?.send(REACT_APP_RABBITMQ_COMMENT, {}, JSON.stringify(request));
  };

  const editComment = async () => {
    if (!initValue?.taskActivityCode) return;

    const plainText = formDataComment.content?.replace(/<\/?[^>]+(>|$)/g, "");

    if (
      plainText?.trim()?.length === 0 ||
      plainText?.trim() === oldContent?.trim()
    ) {
      return;
    }

    const request = {
      taskCode: selectedTask?.taskCode,
      projectCode: selectedTask?.projectCode,
      notificationStatus: formDataComment.isRegisterNotice
        ? NOTIFICATION_STATUS.YES
        : NOTIFICATION_STATUS.NO,
      content: formDataComment.content,
    };

    const response = await apiFactory.taskActivityApi.updateTaskActivity(
      initValue?.taskActivityCode,
      request
    );

    if (response?.status !== 200) return;

    if (!initValue?.parentTaskActivityCode) {
      setCommentList((prevList) =>
        prevList.map((item) =>
          item.taskActivityCode === initValue?.taskActivityCode
            ? {
                ...item,
                content: formDataComment.content,
                notificationStatus: formDataComment.isRegisterNotice
                  ? NOTIFICATION_STATUS.YES
                  : NOTIFICATION_STATUS.NO,
                isEdited: true,
              }
            : item
        )
      );
    }

    if (initValue?.parentTaskActivityCode) {
      setCommentList((prevList) =>
        prevList.map((item) => {
          if (item.taskActivityCode === initValue?.parentTaskActivityCode) {
            return {
              ...item,
              childTaskActivity: item.childTaskActivity.map((itemChild) =>
                itemChild.taskActivityCode === initValue?.taskActivityCode
                  ? {
                      ...itemChild,
                      content: formDataComment.content,
                      notificationStatus: formDataComment.isRegisterNotice
                        ? NOTIFICATION_STATUS.YES
                        : NOTIFICATION_STATUS.NO,
                      isEdited: true,
                    }
                  : itemChild
              ),
            };
          }
          return item;
        })
      );
    }
  };

  const handleOk = async () => {
    try {
      if (validateContent() && filesPreviewComment?.length === 0) {
        return;
      }

      if (type === "COMMENT" || type === "REPLY") {
        commentReply();
      }

      if (type === "EDIT") {
        await editComment();
      }

      setIsModalReplyComment(false);
    } catch (e) {
      openNotificationError("Comment reply fail: " + e);
    }
  };

  const handleCancel = () => {
    if (type === "EDIT" || type === "DETAIL") {
      setFilesPreviewComment([]);
    }
    setIsModalReplyComment(false);
  };

  const isPreviewFile = (fileName) => {
    if (type !== "DETAIL") return false;

    return isSupportedFileType(fileName);
  };

  const openFilePreviewModal = (file) => {
    if (!isPreviewFile(file?.fileName)) return;

    const path = file?.path ?? file?.pathUrl ?? "";

    if (!path) {
      toast.error(
        languageMap?.["preview.error.pathNotFound"] ??
          "Error opening file due to non-existent path"
      );
      return;
    }
    setUrlPreview(
      `${process.env.REACT_APP_FILE_STORE}/task/${selectedTask?.taskCode}${path}`
    );
    setResourceId(file?.resourceId);
    setIsFilePreviewModal(true);
  };

  useEffect(() => {
    if ((type === "EDIT" || type === "DETAIL") && currentComment) {
      const plainText = currentComment?.content?.replace(/<\/?[^>]+(>|$)/g, "");

      setInitValue(currentComment);
      setOldContent(plainText);
      setTaskFormData({
        type: "UPDATE_FIELD",
        taskCode: type + selectedTask?.taskCode,
        field: "content",
        value: currentComment?.content,
      });
      setTaskFormData({
        type: "UPDATE_FIELD",
        taskCode: type + selectedTask?.taskCode,
        field: "selectedWorkActivity",
        value: currentComment?.typeCode,
      });
      setTaskFormData({
        type: "UPDATE_FIELD",
        taskCode: type + selectedTask?.taskCode,
        field: "isRegisterNotice",
        value: currentComment?.notificationStatus === NOTIFICATION_STATUS.YES,
      });

      if (currentComment?.attachFiles) {
        setFilesPreviewComment(
          currentComment?.attachFiles?.map((item) => ({
            taskCode: selectedTask?.taskCode,
            fileName: item?.name,
            path: item?.path,
            totalVolume: item?.size,
            resourceId: item?.resourceId,
          }))
        );
      }
    }

    if ((type === "COMMENT" || type === "REPLY") && user) {
      setInitValue({
        content: "",
        userCode: user?.userCode,
        mentionCodes: [],
      });
    }
  }, [user, type, currentComment]);

  useEffect(() => {
    if (initValue && memberList.length > 0) {
      const members = memberList.filter(
        (item) => item?.userCode !== user?.userCode
      );

      const mentionsOption = members.map((member) => ({
        ...member,
        value: member?.name,
        label: member?.name,
      }));

      if (type === "DETAIL" || type === "EDIT") {
        const defaultValue = mentionsOption
          .filter((item) => initValue?.mentionCodes?.includes(item?.userCode))
          .map((item) => `@${item.value}`);

        setTaskFormData({
          type: "UPDATE_FIELD",
          taskCode: type + selectedTask?.taskCode,
          field: "mentionInput",
          value: defaultValue.join(" "),
        });
      }

      setMentionsOption(mentionsOption);
      setMentionsOptionDefault(mentionsOption);
    }
  }, [initValue, memberList, type]);

  return (
    <>
      {initValue && (
        <Modal
          title={languageMap?.["project.task.comment.title"] ?? "Task Activity"}
          width={700}
          open={isModalReplyComment}
          onOk={handleOk}
          onCancel={handleCancel}
          style={{ zoom: isMobile && "0.8" }}
          footer={
            type !== "DETAIL"
              ? [
                  <Button
                    key="submit"
                    type="primary"
                    onClick={handleOk}
                    disabled={
                      validateContent() && filesPreviewComment?.length === 0
                    }
                  >
                    {type === "EDIT"
                      ? "Update"
                      : languageMap?.["project.task.comment.submitBtn"] ??
                        "Submit"}
                  </Button>,
                  <Button type="primary" onClick={handleCancel} danger>
                    {languageMap?.["project.task.comment.closeBtn"] ?? "Close"}
                  </Button>,
                ]
              : [
                  <Button type="primary" onClick={handleCancel} danger>
                    {languageMap?.["project.task.comment.closeBtn"] ?? "Close"}
                  </Button>,
                ]
          }
        >
          <div className="py-4">
            <div className="flex justify-between items-center">
              <div>
                <Avatar
                  style={{
                    backgroundColor: getPropertyColorByType(
                      "BACKGROUND",
                      initValue
                    ),
                    color: getPropertyColorByType("COLOR", initValue),
                  }}
                  className="mr-2"
                  src={getAvatarSrc(initValue)}
                >
                  {getMemberName(initValue?.userCode)[0]}
                </Avatar>
                <span className="member-name">
                  {getMemberName(initValue?.userCode)}
                </span>
              </div>
              <span>
                {initValue?.commentTime
                  ? formatTime(initValue?.commentTime)
                  : ""}
              </span>
            </div>
          </div>
          <div className="flex justify-between items-center pl-4 pr-4 pb-4">
            <Radio.Group
              onChange={(e) =>
                setTaskFormData({
                  type: "UPDATE_FIELD",
                  taskCode: type + selectedTask?.taskCode,
                  field: "selectedWorkActivity",
                  value: e.target.value,
                })
              }
              value={formDataComment.selectedWorkActivity}
              disabled={type === "DETAIL" || type === "EDIT"}
            >
              {workActivity.map((item) => (
                <Radio value={item.code} key={item.code}>
                  {user.language === "us"
                    ? item.enName
                    : user.language === "vn"
                      ? item.vnName
                      : user.language === "kr"
                        ? item.krName
                        : item.enName}
                </Radio>
              ))}
            </Radio.Group>
            <Checkbox
              onChange={() =>
                setTaskFormData({
                  type: "UPDATE_FIELD",
                  taskCode: type + selectedTask?.taskCode,
                  field: "isRegisterNotice",
                  value: !formDataComment.isRegisterNotice,
                })
              }
              checked={formDataComment.isRegisterNotice}
              disabled={type === "DETAIL" || type === "EDIT"}
            >
              {languageMap?.["project.task.comment.register"] ??
                "Register as notice"}
            </Checkbox>
          </div>
          <ReactQuill
            readOnly={type === "DETAIL"}
            theme="snow"
            placeholder={type === "COMMENT" ? "Comment..." : "Reply comment..."}
            className="my-quill-editor"
            modules={modules}
            formats={formats}
            value={formDataComment.content}
            onChange={(value) =>
              setTaskFormData({
                type: "UPDATE_FIELD",
                taskCode: type + selectedTask?.taskCode,
                field: "content",
                value: value,
              })
            }
          />
          <div
            className={`flex justify-between items-center${isMobile ? " pt-20 " : " pt-14 "}`}
          >
            <span className="flex flex-col items-center font-bold no-wrap-expand w-24">
              {languageMap?.["project.task.comment.mentions"] ?? "Mentions"}
            </span>
            <Mentions
              autoSize={{
                minRows: 1,
                maxRows: 3,
              }}
              placeholder="@Mentions"
              allowClear
              className="mr-1"
              value={formDataComment.mentionInput}
              onChange={handleChangeMentions}
              onSelect={handleSelectMentions}
              options={mentionsOption}
              disabled={type === "DETAIL" || type === "EDIT"}
            />
            {(type === "COMMENT" || type === "REPLY") && (
              <Button type="text" onClick={() => setIsModalMentionMember(true)}>
                <UserAddOutlined className="text-[18px]" />
              </Button>
            )}
          </div>
          <div className="flex justify-start items-center py-4">
            <div className="flex flex-col items-center no-wrap-expand w-24">
              <div className="font-bold mb-2">
                {languageMap?.["project.task.comment.files"] ?? "Files"}
                <span className="text-[green]">
                  (
                  {
                    filesPreviewComment?.filter(
                      (item) => item?.taskCode === selectedTask?.taskCode
                    )?.length
                  }
                  )
                </span>
              </div>
              {downloadProgress > 0 ? (
                <button
                  onClick={() =>
                    handleCancelDownload(
                      abortController,
                      setAbortController,
                      setDownloadProgress,
                      isActionDisabled,
                      setIsActionDisabled
                    )
                  }
                >
                  <CloseOutlined size={20} color="#2b9853" />{" "}
                </button>
              ) : (
                type === "DETAIL" && (
                  <DowloadAllReplyComment currentComment={currentComment} />
                )
              )}
              {downloadProgress > 0 && (
                <div className="flex items-center w-full">
                  <Progress
                    percent={20}
                    showInfo={false}
                    strokeColor="#52c41a"
                    size="small"
                  />
                </div>
              )}
            </div>
            <div className="w-full border-[1px] border-[#CCCCCC] border-solid rounded-lg p-4 h-[234px] overflow-y-auto">
              <Row gutter={[16, 16]}>
                {filesPreviewComment
                  ?.filter((item) => item?.taskCode === selectedTask?.taskCode)
                  ?.map((file) => (
                    <Col
                      className="file-container cursor-pointer"
                      span={24}
                      key={file?.requestUuid}
                      onClick={() => openFilePreviewModal(file)}
                    >
                      <div className="flex justify-between items-center">
                        <div className="flex items-center">
                          {getFileIcon(file?.fileName)}

                          <div className="flex flex-col file-info">
                            <span className="mt-2">
                              {truncateFileName(file?.fileName)}
                            </span>
                            <span className="text-[12px]">
                              <span
                                className={
                                  isPreviewFile(file?.fileName) ? "volume" : ""
                                }
                              >
                                {standardizeVolume(file?.totalVolume)}
                              </span>
                              {isPreviewFile(file?.fileName) && (
                                <span className="preview-text">
                                  {languageMap?.["preview.click"] ??
                                    "Click to preview"}
                                </span>
                              )}
                            </span>
                          </div>
                        </div>

                        {(type === "COMMENT" || type === "REPLY") && (
                          <Button
                            type="text"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteFile(file?.requestUuid);
                            }}
                            className="mt-2"
                          >
                            <FaTrash color="red" />
                          </Button>
                        )}
                        {type === "DETAIL" && <ReplyCommentFile file={file} />}
                      </div>
                    </Col>
                  ))}
                {uploadFiles?.map((item) => {
                  if (item?.taskCode === selectedTask?.taskCode) {
                    return (
                      <PreviewFile
                        requestUuid={item?.requestUuid}
                        content={item?.path}
                        file={{
                          volume: item?.volume,
                          originalName: item?.fileName,
                          resourceId: item?.resourceId,
                          pathUrl: item?.path,
                        }}
                        contentType={item?.contentType}
                        percentProgress={Math.round(
                          (item?.totalChunkUploaded * 100) / item?.totalChunk
                        )}
                        totalVolume={item?.totalVolume}
                        path={type === "COMMENT" ? "comment" : "reply"}
                      />
                    );
                  }

                  return <></>;
                })}
              </Row>
            </div>

            {(type === "COMMENT" || type === "REPLY") && (
              <Upload
                name="file"
                onChange={handleChangeUpload}
                multiple
                itemRender={() => <></>}
                beforeUpload={() => {
                  return false;
                }}
                fileList={filesPreviewComment}
              >
                <Button type="text">
                  <FolderOpenOutlined className="text-[20px]" />
                </Button>
              </Upload>
            )}
          </div>
        </Modal>
      )}
      {isModalMentionMember && (
        <MemberProjectModal
          isOpen={isModalMentionMember}
          onClose={() => setIsModalMentionMember(false)}
          onCreate={handleSubmitMentionMember}
          onRemove={handleSubmitRemoveMember}
          selectedTask={selectedTask}
          memberList={mentionsOption}
          type="MENTION"
        />
      )}
      {isFilePreviewModal && (
        <FilePreviewModal
          isOpen={isFilePreviewModal}
          onClose={() => setIsFilePreviewModal(false)}
          urlPreview={urlPreview}
          resourceId={resourceId}
        />
      )}
    </>
  );
};

export { ModalReplyComment };
